var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavHeartEmpty = function SvgFavHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    d: "M21.563 2.5C18.91 2.5 16.546 4.124 15 6.25 13.454 4.124 11.09 2.5 8.437 2.5 3.777 2.5 0 6.696 0 11.875 0 22.598 15 28.75 15 28.75s15-6.152 15-16.875C30 6.696 26.223 2.5 21.562 2.5Zm0 2.5c3.273 0 5.937 3.084 5.937 6.875 0 7.494-9.434 12.65-12.5 14.128-3.069-1.48-12.5-6.636-12.5-14.128C2.5 8.084 5.164 5 8.438 5c1.603 0 3.302 1.016 4.54 2.721L15 10.5l2.021-2.778C18.26 6.016 19.96 5 21.562 5Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fav_heart_empty_svg__a",
    width: 26,
    height: 22,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.563 5c3.273 0 5.937 3.084 5.937 6.875 0 7.494-9.434 12.65-12.5 14.128-3.069-1.48-12.5-6.636-12.5-14.128C2.5 8.084 5.164 5 8.438 5c1.603 0 3.302 1.016 4.54 2.721L15 10.5l2.021-2.778C18.26 6.016 19.96 5 21.562 5Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fav_heart_empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.563 2.5C18.91 2.5 16.546 4.356 15 6.786 13.454 4.356 11.09 2.5 8.437 2.5 3.777 2.5 0 7.296 0 13.214 0 25.47 15 32.5 15 32.5s15-7.031 15-19.286C30 7.296 26.223 2.5 21.562 2.5Z",
    clipRule: "evenodd"
  }))));
};
export default SvgFavHeartEmpty;